// extracted by mini-css-extract-plugin
export var carrierTab = "_43-0";
export var carrierTabActive = "_43-1 _43-0";
export var carrierTabInactive = "_43-2 _43-0";
export var carrierTabLabel = "_43-3";
export var carrierTabLabelActive = "_43-4 _43-3";
export var carrierTabLabelInactive = "_43-5 _43-3";
export var carrierTabPercentage = "_43-6";
export var carrierTabPercentageActive = "_43-7 _43-6";
export var carrierTabPercentageInactive = "_43-8 _43-6";
export var carrierTabWinnable = "_43-9";
export var carrierTabWinnableActive = "_43-a _43-9";
export var carrierTabWinnableInactive = "_43-b _43-9";
export var comparisonContainer = "_43-d";
export var missingRateButton = "_43-n";
export var missingRateButtonActive = "_43-o _43-n";
export var missingRateButtonInactive = "_43-p _43-n";
export var missingRateButtonLabel = "_43-q";
export var missingRateButtonLabelActive = "_43-r _43-q";
export var missingRateButtonLabelInactive = "_43-s _43-q";
export var sidebar = "_43-c";
export var strategyButton = "_43-e";
export var strategyButtonActive = "_43-f _43-e";
export var strategyButtonDescription = "_43-k";
export var strategyButtonDescriptionActive = "_43-l _43-k";
export var strategyButtonDescriptionInactive = "_43-m _43-k";
export var strategyButtonInactive = "_43-g _43-e";
export var strategyButtonLabel = "_43-h";
export var strategyButtonLabelActive = "_43-i _43-h";
export var strategyButtonLabelInactive = "_43-j _43-h";
export var unitToggleButton = "_43-t";
export var unitToggleButtonActive = "_43-u _43-t";
export var unitToggleButtonInactive = "_43-v _43-t";
export var unitToggleButtonLabel = "_43-w";
export var unitToggleButtonLabelActive = "_43-x _43-w";
export var unitToggleButtonLabelInactive = "_43-y _43-w";